module.exports = __webpack_public_path__ + "fonts/f012ba059918e7b4ea179f011aeea673.txt";